var Actions;
(function (Actions) {
    Actions["GET_GROUP_LIST"] = "getGroupList";
    Actions["GET_GROUP_LIST_CODE_DESC"] = "getGroupListIdDesc";
    Actions["CREATE_GROUP_LIST"] = "createGroupList";
    Actions["UPDATE_GROUP_LIST"] = "updateGroupList";
    Actions["GET_GROUP_LIST_FILTER"] = "getGroupListFilter";
    Actions["GET_GROUP_DATA"] = "getGroupData";
    Actions["UPDATE_SELECTED_GROUP_CODE"] = "updateSelectedGroupId";
    Actions["UPDATE_SELECTED_GROUP_DESC"] = "updateSelectedGroupDesc";
    Actions["UPDATE_SELECTED_GROUP_ACTIVE"] = "updateSelectedGroupActive";
    Actions["UPDATE_GROUP_SIZE"] = "updateGroupSize";
    Actions["RESET_GROUP_FILTER"] = "resetGroupFilter";
    Actions["DOWNLOAD_GROUP"] = "downloadGroup";
    Actions["UPDATE_GROUP_PAGE_FILTER"] = "updateGroupPageFilter";
    Actions["UPDATE_SEARCH_GROUP_DESC"] = "updateSearchGroupDesc";
    Actions["UPDATE_SEARCH_GROUP_CODE"] = "updateSearchGroupCode";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_GROUP_WAS_FIRST_LOAD"] = "setGroupWasFirstLoad";
    Mutations["SET_GROUP_LOADING"] = "setGroupLoading";
    Mutations["SET_GROUP_HANDLE_PAGE"] = "setGroupHandlePage";
    Mutations["SET_GROUP_LIST"] = "setGroupList";
    Mutations["SET_GROUP_LIST_CODE"] = "setGroupListId";
    Mutations["SET_GROUP_LIST_DESC"] = "setGroupListDesc";
    Mutations["SET_GROUP_PAGE"] = "setGroupPage";
    Mutations["SET_GROUP_LOAD_PAGE"] = "setGroupLoadPage";
    Mutations["SET_SELECTED_GROUP_CODE"] = "setSelectedGroupId";
    Mutations["SET_SELECTED_GROUP_DESC"] = "setSelectedGroupDesc";
    Mutations["SET_SELECTED_GROUP_ACTIVE"] = "setSelectedGroupActive";
    Mutations["SET_GROUP_STATUS"] = "setGroupStatus";
    Mutations["SET_GROUP_SIZE"] = "setGroupSize";
    Mutations["SET_GROUP_USE_FILTER"] = "setGroupUseFilter";
    Mutations["SET_GROUP_PAGE_FILTER"] = "setGroupPageFilter";
    Mutations["SET_GROUP_WAS_LOAD_QUICK_FILTER"] = "setGroupWasLoadQuickFilter";
    Mutations["SET_GROUP_SEARCH_BY"] = "setGroupSearchBy";
    Mutations["SET_GROUP_SEARCH_KEY"] = "setGroupSearchKey";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
